import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import { useTranslation } from "react-i18next";
import { LessonRecording } from "../common/api";
import { Button, Modal } from "react-bootstrap";
import { ApiContext } from "../common/context/ApiContext";
import { useLoadingIndicator } from "../common/context/LoadingIndicatorContext";

export const LessonRecordingEditMenu = ({
  anchor,
  isOpen,
  onLessonRecordingDeleted,
  onClose,
  recording,
}: {
  anchor: HTMLButtonElement;
  isOpen: boolean;
  onLessonRecordingDeleted: (LessonRecording) => void;
  onClose: () => void;
  recording: LessonRecording | null;
}) => {
  const { t } = useTranslation();
  const { deleteLessonRecording } = React.useContext(ApiContext);
  const { startLoading, stopLoading } = useLoadingIndicator(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);

  const doDelete = React.useCallback(() => {
    if (recording !== null) {
      startLoading();
      deleteLessonRecording(recording.id).then(() => {
        stopLoading();
        setIsDeleteModalOpen(false);
        onLessonRecordingDeleted(recording);
      });
    }
  }, [
    recording,
    startLoading,
    deleteLessonRecording,
    stopLoading,
    setIsDeleteModalOpen,
    onLessonRecordingDeleted,
  ]);

  return (
    <>
      <Menu
        open={isOpen}
        onClose={onClose}
        anchorEl={anchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableAutoFocusItem
        slotProps={{
          paper: {
            style: {
              width: 250,
              marginTop: 6,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            onClose();
            setIsDeleteModalOpen(true);
          }}
        >
          <ListItemText>{t("generic_delete")}</ListItemText>
        </MenuItem>
      </Menu>

      {/* Delete modal */}
      <Modal
        show={isDeleteModalOpen}
        onHide={() => {
          setIsDeleteModalOpen(false);
          onClose();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("lesson_replays_delete_title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("lesson_replays_delete_description")}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setIsDeleteModalOpen(false);
              onClose();
            }}
          >
            {t("generic_cancel")}
          </Button>
          <Button variant="danger" onClick={doDelete}>
            {t("generic_delete")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
